import { render, staticRenderFns } from "./AppIconActive.vue?vue&type=template&id=18d728ed&scoped=true"
import script from "./AppIconActive.vue?vue&type=script&lang=js"
export * from "./AppIconActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d728ed",
  null
  
)

export default component.exports